import { request, makePath } from './http';
const API_NAME = 'provider';

export function getProfile(uuid) {
  return request('GET', makePath(API_NAME, uuid));
}

export function searchProfiles(params) {
  return request('GET', makePath(API_NAME), {params: params});
}

export function updateProfile(uuid, data) {
  return request('PATCH', makePath(API_NAME, uuid), {body: data});
}

export function adminUpdateProfile(uuid, data) {
  return request('PATCH', makePath(API_NAME, 'admin', uuid), {body: data});
}

export function createProvider(data) {
  return request('POST', makePath(API_NAME), {body: data});
}

export function getListings(provider_uuid, exclude_inactive=true) {
  return request('GET', makePath(API_NAME, provider_uuid, 'listing'), {params: {exclude_inactive}});
}

export function getListing(uuid_or_slug) {
  return request('GET', makePath(API_NAME, 'listing', uuid_or_slug));
}

export function searchListings(params) {
  return request('GET', makePath(API_NAME, 'listing'), {params: params});
}

export function updateListing(provider_uuid, listing_uuid, data) {
  return request('PATCH', makePath(API_NAME, provider_uuid, 'listing', listing_uuid), {body: data});
}

export function createListing(provider_uuid, data) {
  return request('POST', makePath(API_NAME, provider_uuid, 'listing'), {body: data});
}

export function getPremises(uuid, exclude_inactive=true) {
  return request('GET', makePath(API_NAME, uuid, 'premise'), {params: {exclude_inactive}});
}

export function getPremise(provider_uuid, premise_uuid) {
  return request('GET', makePath(API_NAME, provider_uuid, 'premise', premise_uuid));
}

export function updatePremise(provider_uuid, premise_uuid, data) {
  return request('PATCH', makePath(API_NAME, provider_uuid, 'premise', premise_uuid), {body: data});
}

export function createPremise(provider_uuid, data) {
  return request('POST', makePath(API_NAME, provider_uuid, 'premise'), {body: data});
}

export function getUsers(provider_uuid) {
  return request('GET', makePath(API_NAME, provider_uuid, 'users'));
}

export function removeRole(provider_uuid, account_uuid) {
  return request('POST', makePath(API_NAME, provider_uuid, 'removerole'), {body: {account_uuid}});
}

export function changeRoles(provider_uuid, account_uuid, role_names) {
  return request('POST', makePath(API_NAME, provider_uuid, 'changeroles'), {body: {account_uuid, role_names}});
}

export function webToLead(data) {
  return request('POST', makePath(API_NAME, 'lead'), {body: data});
}

export function locationAutocomplete(query, limit=10) {
  return request('GET', makePath(API_NAME, 'location/autocomplete'), {params: {query, limit}});
}

export function getProviderImageUploadUrl(provider_uuid, file_name, content_type) {
  return request('GET', makePath(API_NAME, provider_uuid, 'imageuploadurl'),
    {params: {
      file_name,
      content_type,
    }}
  );
}

export function getListingImageUploadUrl(provider_uuid, listing_uuid, file_name, content_type) {
  return request('GET', makePath(API_NAME, provider_uuid, 'listing', listing_uuid, 'imageuploadurl'),
    {params: {
      file_name,
      content_type,
    }}
  );
}
